import { IFileDesc, IStuffBeingUploaded, IUploadFile } from '@app-types/websocket/file.types';
import axios from 'axios';
import { buffers, Channel, END, eventChannel } from 'redux-saga';
import { cacheDelete, cachePeek } from './upload.cache';


function isBlobLike(x: any): x is Blob {
  return !!x && typeof x === "object" && typeof x.size === "number" && typeof x.slice === "function";
}

function pickBody(upload: IStuffBeingUploaded): Blob | undefined {
  const cached = cachePeek(upload.internalId);
  if (cached?.body && isBlobLike(cached.body)) return cached.body;

  return undefined;
}

export function requestChatUploadSlot(upload: IUploadFile, familyId: number, authorization: string): Promise<{uploadFile: IFileDesc}> {
  const desc: IFileDesc = {
    fileName: upload.name,
    fileSize: upload.size,
    internalId: "" + upload.internalId,
  };

  return axios.post('https://api.varannanvecka.app:443/v1/upload/ai/' + familyId + '/chat/slot', desc, {
    headers: {
      Authorization: authorization,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    timeout: 30000,
    validateStatus: (status: number) => status >= 200 && status < 300,
  }).then((response: any) => {
    const data = response?.data || {};
    const uploadUrl = data.url || data.URL;
    if (!data.id || !uploadUrl) {
      throw new Error('Invalid chat upload slot response');
    }

    return {
      uploadFile: {
        ...data,
        id: data.id,
        fileName: data.fileName || upload.name,
        fileSize: data.fileSize || upload.size,
        internalId: data.internalId || "" + upload.internalId,
        url: uploadUrl,
        permanentURL: data.permanentURL || data.permanentUrl,
      },
    };
  });
}

export function uploadFile(upload: IStuffBeingUploaded): Channel<any> {
  const instance = axios.create({ baseURL: '' });
  /* tslint:disable:no-string-literal */
  delete instance.defaults.headers.common['Authorization'];
  /* tslint:enable:no-string-literal */

  return eventChannel(emitter => {
    try {
      if (!upload.url) throw new Error('No URL');

      const body = pickBody(upload);
      if (!body) throw new Error('No data/file on upload payload (and nothing in cache)');

      const contentType = (body as any)?.type || 'application/octet-stream';

      instance
        .put(upload.url, body, {
          headers: {
            'Content-Type': contentType,
            'Accept': 'application/json',
          },
          validateStatus: (status: number) => status >= 200 && status < 300,
          maxBodyLength: Infinity as any,
          maxContentLength: Infinity as any,
          onUploadProgress: (progressEvent: any) => {
            const total = progressEvent.total;
            const loaded = progressEvent.loaded;
            if (total && total > 0) {
              const percentage = Math.floor((loaded / total) * 100);
              emitter({ progress: { ...upload, loaded: percentage } });
            }
          },
        })
        .then((resp: any) => {
          cacheDelete(upload.internalId); // ✅ cleanup
          emitter({ result: { ...upload, loaded: 100, httpStatus: resp?.status } });
          emitter(END);
        })
        .catch((err: any) => {
          cacheDelete(upload.internalId); // ✅ cleanup
          emitter({ error: { ...upload, httpStatus: err?.response?.status, cause: err }, loaded: 0 });
          emitter(END);
        });
    } catch (e) {
      emitter({ error: upload, loaded: 0 });
      emitter(END);
    }

    return () => undefined;
  }, buffers.sliding(20));
}



// WEBPACK FOOTER //
// ./src/services/file/file.http.ts